
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Ouf! Il s'en est fallu de peu!`}</strong>{` Sur le chemin du travail, respectez les
règles de distance. Vous évitez ainsi d'être infecté par un passager dans les
transports publics.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;